/**
 * Signup 画面: 初回ログイン直後にハンドル (英数 3〜10 文字) を登録する。
 *
 * Google OIDC 認証は通っているが、 D1 の `users.handle` が NULL の状態。
 * App.tsx 側で `me.handle` が無いと自動でこの画面に飛ばされる。
 *
 * 制約:
 * - 英数のみ (a-z, A-Z, 0-9)。 大小区別なしで一意。
 * - 3〜10 文字。
 * - 重複は server から 409 で返るので、 そのとき再入力させる。
 */

import { useState } from 'react';
import { navigate } from '../lib/navigate';
import { useSession } from '../state/session';

const HANDLE_RE = /^[A-Za-z0-9]{3,10}$/;

export function Signup() {
  const setHandle = useSession((s) => s.setHandle);
  const me = useSession((s) => s.me);
  const [value, setValue] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const localValid = HANDLE_RE.test(value);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!localValid || submitting) return;
    setSubmitting(true);
    setError(null);
    const r = await setHandle(value);
    setSubmitting(false);
    if (r.ok) {
      // 登録完了 → ホームへ
      navigate('/');
      return;
    }
    setError(r.error);
  };

  // すでに handle が設定されている (= 何かの拍子にこの画面に来た) ときはホームへ。
  if (me?.handle) {
    navigate('/');
    return null;
  }

  return (
    <main className="centered">
      <div className="card signup-card">
        <h1>ようこそ</h1>
        <p className="muted">
          ゲームで使う名前を決めてください。 あとから設定で変更できます。
        </p>
        <form onSubmit={submit} className="signup-form">
          <label className="signup-label" htmlFor="handle-input">
            ハンドル (英数 3〜10 文字)
          </label>
          <input
            id="handle-input"
            type="text"
            className="signup-input"
            value={value}
            maxLength={10}
            autoFocus
            autoComplete="off"
            onChange={(e) => setValue(e.target.value)}
            placeholder="例: alice23"
            disabled={submitting}
          />
          <p className={`signup-hint ${value && !localValid ? 'bad' : ''}`}>
            {value === ''
              ? 'a〜z, A〜Z, 0〜9 のみ'
              : localValid
                ? 'OK'
                : '英数字のみ、 3〜10 文字'}
          </p>
          {error && <p className="signup-error">{error}</p>}
          <button
            type="submit"
            className="btn-primary signup-cta"
            disabled={!localValid || submitting}
            data-testid="signup-submit"
          >
            {submitting ? '登録中…' : '登録'}
          </button>
        </form>
      </div>
    </main>
  );
}
